import React from 'react';
import styled from 'styled-components';

import Breadcrumbs from '@rover/components/src/navigation/Breadcrumbs';
import { Box } from '@rover/kibble/core';
import AppStoreCallout from '@rover/react-lib/src/pages/shared/AppStoreCallout/AppStoreCallout';
import type { CountryConfigurationUrls } from '@rover/rsdk/src/apiClient/latest/model/countryConfigurationUrls';
import type { SeoLocationDetails } from '@rover/rsdk/src/apiClient/latest/model/seoLocationDetails';
import { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import type { LinkedLocation } from '@rover/types/src/apiResponses/FetchSeoLocationResponse';

import SeoLinkedLocationsAndNeighborhoods from './SeoLinkedLocationsAndNeighborhoods';

type Props = {
  countryConfigurationUrls: CountryConfigurationUrls;
  seoLocation: Pick<SeoLocationDetails, 'text' | 'breadcrumbData' | 'serviceTypeSlug'> &
    React.ComponentProps<typeof SeoLinkedLocationsAndNeighborhoods>['seoLocation'];
  linkedLocations: LinkedLocation[];
  topNeighborhoodServices: LinkedLocation[];
};

const StyledSeoText = styled.div`
  a {
    text-decoration: underline;
  }
`;

const SeoLocationFooter: React.FC<Props> = ({
  countryConfigurationUrls,
  seoLocation,
  linkedLocations,
  topNeighborhoodServices,
}) => {
  const { indexUrl } = camelize(countryConfigurationUrls, true);
  const hasBreadcrumbData = !!seoLocation.breadcrumbData?.length;
  const isTraining = seoLocation.serviceTypeSlug === ServiceTypeSlugEnum['dog-training'];

  return (
    <Box
      background="primary"
      borderTop="0 none"
      paddingTop={['6x', '8x']}
      paddingRight="0x"
      paddingLeft="0x"
      paddingBottom="8x"
    >
      <StyledSeoText
        data-qa-id="search-location-text"
        dangerouslySetInnerHTML={{
          __html: seoLocation.text,
        }}
      />

      <Box my="16x">
        <AppStoreCallout featureToShow={isTraining ? 'training' : 'default'} />
      </Box>

      {hasBreadcrumbData && <Breadcrumbs breadcrumbData={seoLocation.breadcrumbData} />}

      <SeoLinkedLocationsAndNeighborhoods
        linkedLocations={linkedLocations}
        topNeighborhoods={topNeighborhoodServices}
        seoLocation={seoLocation}
        indexUrl={indexUrl}
      />
    </Box>
  );
};

export default SeoLocationFooter;
